import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const updatePointsApplicationAdminEndpoint = {
    [pointsEndpointIds.UPDATE_POINTS_APPLICATION_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
    },
};
